exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentSubgroups .title{font-size:1.4em}.studentSubgroups .title:first-of-type{margin-bottom:5px}.studentSubgroups .buttonSuccess,.studentSubgroups .section{margin-bottom:15px}.studentSubgroups .buttonSuccess{margin-top:25px}.studentSubgroups label input{margin-right:5px}.studentSubgroups .form-control{width:40%;display:inline-block}.studentSubgroups .newGroupContainer .buttonDropdown{margin-left:15px}.studentSubgroups .buttonDropdown .dropdown-toggle{padding-left:0}.studentSubgroups .buttonDropdown .dropdown-toggle span.glyphicon{margin-right:5px}.studentSubgroups .buttonDropdown .buttonDropdown .scrollable-menu li{margin-right:0}.studentSubgroups .groupInformation .glyphicon{vertical-align:middle;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster/student_subgroups.scss
// module id = 1337
// module chunks = 0